import ApiClient from "./ApiClient";

let organisationId = null;

const AppsClientFactory = () => {
  return () =>
    ApiClient({
      baseURL: `/api/apps/${organisationId ?? 0}`,
    });
};

export const setOrganisationId = (id) => {
  organisationId = id;
};

const AppsClient = AppsClientFactory();

export default AppsClient;
